const sliderInit = () => {
  let slider;
  let isDragging = false;
  let startX, scrollLeft;
  let lastDragTime = 0;

  slider = document.querySelector(".card_relatedslide_block");
  const prevButton = document.getElementById("slider_nav_prev");
  const nextButton = document.getElementById("slider_nav_next");
  // Only the legacy drawer upsell has these controls; it runs again after every
  // cart update, so bind each rendered slider once
  if (!slider || !prevButton || !nextButton || slider.dataset.sliderBound) return;
  slider.dataset.sliderBound = "true";

  const sliderScroll = function (forwards) {
    const tileWidth = slider.querySelector(".related-main").getBoundingClientRect().width;
    slider.scrollLeft += forwards ? tileWidth : -tileWidth;
    updateActiveSlide();
  };

  const updateActiveSlide = function () {
    const slides = slider.querySelectorAll(".related-main");
    const sliderRect = slider.getBoundingClientRect();

    slides.forEach((slide) => {
      const slideRect = slide.getBoundingClientRect();
      const isActive = slideRect.left <= sliderRect.left && slideRect.right >= sliderRect.right;
      slide.classList.toggle("active", isActive);
    });

    const cartButton = document.getElementById('cart-button-active');
    if (cartButton) {
      const isActive = Array.from(slides).some(slide => slide.classList.contains('active'));
      cartButton.classList.toggle("cart_btn_active", isActive); // Toggle class on cart button
    }

  };

  const startDrag = function (e) {
    isDragging = true;
    startX = e.clientX;
    scrollLeft = slider.scrollLeft;
    slider.style.scrollBehavior = "auto";
    slider.style.cursor = "grabbing";
  };

  const endDrag = function () {
    isDragging = false;
    slider.style.scrollBehavior = "smooth";
    slider.style.cursor = "grab";
    updateActiveSlide();
  };

  const drag = function (e) {
    if (!isDragging) return;
    const now = performance.now();
    if (now - lastDragTime < 16) return;
    lastDragTime = now;
    requestAnimationFrame(() => {
      const x = e.clientX - startX;
      const scrollOffset = (x / slider.clientWidth) * slider.scrollWidth;
      slider.scrollLeft = scrollLeft - scrollOffset;
      updateActiveSlide();
    });
  };

  prevButton.addEventListener("click", () => {
    sliderScroll(false);
  });

  nextButton.addEventListener("click", () => {
    sliderScroll(true);
  });

  slider.addEventListener("mousedown", startDrag);
  slider.addEventListener("mouseup", endDrag);
  slider.addEventListener("mouseleave", endDrag);
  slider.addEventListener("mousemove", drag);

  // Initialize active slide on load
  updateActiveSlide();

  // Expose sliderScroll globally (optional, only if needed outside this module)
  window.sliderScroll = sliderScroll;
};

setTimeout(() => {
  sliderInit();
}, 3000);


// document.addEventListener('DOMContentLoaded', function() {
//   // Function to check if the user is in the continental USA
//   function isInContinentalUSA(position) {
//     const lat = position.coords.latitude;
//     const lon = position.coords.longitude;

//     return lat >= 24.396308 && lat <= 49.384358 && lon >= -125.000000 && lon <= -66.934570;
//   }
//   function handleGeolocationError(error) {
//     console.error('Geolocation error:', error.message);
//     // You may want to handle errors in a way that suits your application
//   }

//   function checkuserlocation(){
//   if ('geolocation' in navigator) {
//     // Get the user's current location
//     navigator.geolocation.getCurrentPosition(
//       function(position) {
//         // Check if the user is in the continental USA
//         if (isInContinentalUSA(position)) {
//           var freeShippingElement = document.createElement('p');
//           freeShippingElement.textContent = 'Free shipping';
          
//           // Replace 'your-container-selector' with the actual selector where you want to insert the free shipping text
//           document.querySelector('.totals__total-value').appendChild(freeShippingElement);
//         } else {
//           var outsideUSAElement = document.createElement('p');
//           outsideUSAElement.textContent = 'Calculated at checkout';
          
//           // Replace 'your-container-selector' with the actual selector where you want to insert the message
//           document.querySelector('.totals__total-value').appendChild(outsideUSAElement);
//         }
//       },
//       handleGeolocationError
//     );
//   } else {
//     console.error('Geolocation is not supported in this browser.');
//   }
// }
// checkuserlocation()
// });
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    setTimeout(() => {
      sliderInit();
    }, 2000);
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
    //this.checkuserlocation();
  }
  
  // handleGeolocationError(error) {
  //   console.error('Geolocation error:', error.message);
  //   // You may want to handle errors in a way that suits your application
  // }
  // checkuserlocation() {
  //   if ('geolocation' in navigator) {
  //     // Get the user's current location
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => { // Use arrow function to preserve 'this'
  //         const lat = position.coords.latitude;
  //         const lon = position.coords.longitude;
  
  //         if (lat >= 24.396308 && lat <= 49.384358 && lon >= -125.000000 && lon <= -66.934570) {
  //           var freeShippingElement = document.createElement('p');
  //           freeShippingElement.textContent = 'Free shipping';
  
  //           // Replace 'your-container-selector' with the actual selector where you want to insert the free shipping text
  //           document.querySelector('.totals__total-value').appendChild(freeShippingElement);
  //         } else {
  //           var outsideUSAElement = document.createElement('p');
  //           outsideUSAElement.textContent = 'Calculated at checkout';
  
  //           // Replace 'your-container-selector' with the actual selector where you want to insert the message
  //           document.querySelector('.totals__total-value').appendChild(outsideUSAElement);
  //         }
  //       },
  //       this.handleGeolocationError // Keep the context for the error callback
  //     );
  //   } else {
  //     console.error('Geolocation is not supported in this browser.');
  //   }
  // }

  onCartUpdate() {

    setTimeout(() => {
      sliderInit();
    }, 2000);

    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
      
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
